import { render, staticRenderFns } from "./MlaNoticeSection.vue?vue&type=template&id=e4d8d6fc"
import script from "./MlaNoticeSection.vue?vue&type=script&lang=ts"
export * from "./MlaNoticeSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports